export const brandRegex = /\/brands\/([^\/]+)\//;
export const categoryRegex = /\/(?:category|c)\/(.*)\//;
